import * as React from 'react';
import { useIntl } from 'react-intl';
import useAnalytics from '../../../hooks/useAnalytics';

interface IWidgetCategoryProps {
  title: string;
  value: string;
  active?: boolean;
  handleSelectWidgetCategory: React.Dispatch<React.SetStateAction<string>>;
}

function WidgetCategory(props: IWidgetCategoryProps): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const handleSelectCategory = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const value = event.currentTarget.getAttribute('data-value');
    if (value) {
      trackEvent(['Widget category', 'click', `Select: ${value}`]);
      props.handleSelectWidgetCategory(props.active ? '' : value);
    }
  };

  return (
    <button
      className={`e-widget-category ${props.active ? 'active' : ''}`}
      data-value={props.value}
      onClick={handleSelectCategory}
      title={f(
        { id: 'onlineTemplates.subPage.section.widgetCategories.button.tooltip' },
        { name: props.title }
      )}
    >
      {props.title}
    </button>
  );
}

export default WidgetCategory;
